exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-tabs[data-v-6ee456ae] .v-tabs__container{justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/Settings/TabResetPassword.vue?vue&type=style&index=0&id=6ee456ae&scoped=true&lang=scss&
// module id = 937
// module chunks = 0